import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { DocumentService } from '@app/shared/services';
import { Subscription } from 'rxjs';

@AutoUnsubscribe()
@Component({
    selector: 'delete-secutity-key-progress',
    templateUrl: './delete-security-key-progress.component.html',
    styleUrls: ['./delete-security-key-progress.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:[
      MatProgressBarModule
    ]
})
export class DeleteSecurityKeyProgress implements OnInit, OnDestroy {
  modalData;
  progress;
  continue_tracking = true;
  subscription = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cd: ChangeDetectorRef,
    private documentService: DocumentService,
    private dialogRef: MatDialogRef<DeleteSecurityKeyProgress>
  ) {
    this.modalData = data.deleteSecurityKey;
  }

  ngOnInit(): void {
    this.trackDeleteSecurityKeyDeletionProgress(this.modalData);
  }

  async trackDeleteSecurityKeyDeletionProgress(input) {
    let progressWaittime = 2000;
    let failed = false;

    if (!input.job_id) {
      this.continue_tracking = false; //if there were no forms associted to this key, there would be nothing to track so just move on
    }
    //loop over API call to track progress
    while (this.continue_tracking) {
      await new Promise((resolve, reject) => {
        setTimeout(() => {
          this.subscription.add(
            this.documentService.getDeleteSecurityKeyProgress(input.userid, input.job_id).subscribe((res) => {
              // progressWaittime = 2000; //first check happens right away, next one should wait a bit.
              this.progress = res.data.progress * 100;
              this.cd.markForCheck();
              if (res.data.status_message) {
                this.continue_tracking = false;
                reject(res.data.status_message);
              } else if (res.data.progress >= 1) {
                this.continue_tracking = false;
              }
              resolve('success');
            })
          );
        }, progressWaittime);
      }).catch((error) => {
        failed = true;
      });
    }

    //close dialog and report back success
    this.dialogRef.close({ success: !failed });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
